import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';

export interface FeatureFlags {
  /** Grabación de sesiones con LogRocket. */
  sessionRecording: boolean;
  /** Verificación de identidad (KYC) en la web de cliente. */
  kycVerification: boolean;
}

const ALL_DISABLED: FeatureFlags = { sessionRecording: false, kycVerification: false };

/**
 * Funcionalidades que la configuración puede activar solo para ciertos correos.
 *
 * La lista de correos habilitados no llega nunca al navegador: vive en filas de
 * `system_config` que no son de configuración de cliente
 * (`logrocket_allowed_emails`, `kyc_verification_allowed_emails`) y el backend
 * responde solo con booleanos ya resueltos para el usuario del token.
 *
 * La respuesta se cachea junto con el usuario para el que se pidió: el servicio
 * es singleton y sobrevive a un logout/login sin recarga, así que la decisión de
 * un usuario no puede reutilizarse para otro.
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  private readonly authService = inject(AuthService);

  private cached?: { userKey: string; flags: Promise<FeatureFlags> };

  load(userKey: string): Promise<FeatureFlags> {
    if (this.cached?.userKey !== userKey) {
      this.cached = {
        userKey,
        flags: this.authService
          .featureFlags()
          .then((res) => ({
            sessionRecording: res?.data?.sessionRecording === true,
            kycVerification: res?.data?.kycVerification === true
          }))
          .catch(() => ALL_DISABLED)
      };
    }
    return this.cached.flags;
  }

  clear() {
    this.cached = undefined;
  }
}
